// React imports
import { Flex, Switch, Table } from 'antd';
import { useEffect, useState } from 'react';

// Third-party imports
import { useAuth } from 'react-oidc-context';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import AntDButton from 'src/components/Button';
import { ScrollableContent } from 'src/components/ScrollableContent';
import { IResourceCategory } from 'src/models/Project';
import {
  fetchCategoryActivityOfResource,
  getCategoryActivity,
  updateCategoryActivityStatus,
} from 'src/redux/features/session/slice';
import en from 'src/messages/en.json';

const CategoryActivities = () => {
  const auth = useAuth();
  const dispatch = useDispatch();

  const [dataCategory, setdataCategory] = useState<IResourceCategory[]>([]);

  const [isSaving, setIsSaving] = useState(false);
  const [isLoading, setisloading] = useState(false);
  const onStatusChange = (index) => {
    const clonedData = dataCategory.map((it) => {
      return { ...it };
    });

    clonedData[index].showActivities = !clonedData[index].showActivities;
    setdataCategory([...clonedData]);
  };

  const { data: category, loading: categoryLoading } =
    useSelector(getCategoryActivity);
  const getResourceCategoryActivity = async (Email) => {
    setisloading(true);
    await dispatch(fetchCategoryActivityOfResource({ Email: Email }));
    setisloading(false);
  };

  const columns = [
    {
      title: en.Activities.Title.category,
      dataIndex: 'name',
      key: 'name',
      render: (text: string) => <strong>{text}</strong>,
    },
    {
      title: en.Activities.Title.showActivities,
      dataIndex: 'showActivities',
      key: 'showActivities',
      render: (_: any, _record: any, index: number) => (
        <Switch
          defaultChecked={_record?.showActivities}
          onChange={() => onStatusChange(index)}
          size="small"
        />
      ),
    },
  ];

  useEffect(() => {
    if (!category.length || category.length != dataCategory.length)
      getResourceCategoryActivity(auth.user.profile.email);
    if (category.length > 0) setdataCategory(category);
  }, [category.length]);

  const onSave = async () => {
    setIsSaving(true);

    const response = await dispatch(
      updateCategoryActivityStatus({
        id: 0,
        payload: {
          activities: dataCategory.map((it) => {
            return {
              ...it,
            };
          }),
        },
      }),
    );

    if (response != null) {
      toast.success(en.Projects.Success.categoryStatusUpdated);
    }

    setIsSaving(false);

    getResourceCategoryActivity(auth.user.profile.email);
  };

  return (
    <>
      <ScrollableContent
        minHeight="calc(100vh - 15.75rem)"
        maxHeight="calc(100vh - 15.75rem)"
      >
        <Table
          columns={columns}
          dataSource={dataCategory}
          rowKey="id"
          pagination={false}
          sticky={{ offsetHeader: 0 }}
          loading={isLoading}
        />
      </ScrollableContent>
      <Flex gap={'middle'} justify="flex-end" style={{ paddingTop: '1rem' }}>
        <AntDButton
          disabled={!dataCategory?.length}
          onClick={onSave}
          type="primary"
          htmlType="button"
          loading={isSaving}
          status="Saving..."
          statusOnComplete="Save"
        />
      </Flex>
    </>
  );
};

export default CategoryActivities;
